import { BaseError } from "./BaseError";

export class ForbiddenError extends BaseError {
  readonly status = 403;
}
